import { useState } from "react";
import { addBook } from "../services/api";
import { useNavigate } from "react-router-dom";

function AddBook() {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [publisher, setPublisher] = useState("");
  const [publishedDate, setPublishedDate] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = (e) => {
  e.preventDefault();

  // Book Name
  if (!title.trim() || title.length < 3) {
    alert("Book Name is required (min 3 characters)");
    return;
  }

  // Author Name (only letters & spaces)
  const authorRegex = /^[A-Za-z\s]+$/;
  if (!author.trim() || !authorRegex.test(author)) {
    alert("Author Name is required and should contain only letters");
    return;
  }

  // Publisher
  if (!publisher.trim()) {
    alert("Publisher is required");
    return;
  }

  // Published Date (basic check)
  if (!publishedDate.trim()) {
    alert("Published Date is required");
    return;
  }

  // Summary
  if (!description.trim() || description.length < 10) {
    alert("Summary is required (min 10 characters)");
    return;
  }

  const newBook = {
    title,
    author,
    publisher,
    publishedDate,
    description
  };

  addBook(newBook).then(() => {
    navigate("/");
  });
};


  return (
  <div className="container">
    <h3>Add Book</h3>

    <form className="book-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Book Name"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <input
        type="text"
        placeholder="Author Name"
        value={author}
        onChange={(e) => setAuthor(e.target.value)}
      />

      <input
        type="text"
        placeholder="Publisher"
        value={publisher}
        onChange={(e) => setPublisher(e.target.value)}
      />

      <input
        type="text"
        placeholder="Published Date"
        value={publishedDate}
        onChange={(e) => setPublishedDate(e.target.value)}
      />

      <textarea
        placeholder="Summary / Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <button type="submit">Add Book</button>

    </form>
  </div>
);
}

export default AddBook;
